<template>
    <div>
        <!-- https://www.svgrepo.com/svg/506224/info-small -->
        <svg class="w-10 h-10" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 7.01002L12 7.00003M12 17L12 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </div>
</template>
<script setup lang="ts">
</script>
